import React from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles';
import {ReactComponent as RightArrowSVG} from "../../../assets/images/icon-right.svg";
import { useTranslation } from "react-i18next";
import useCheckPermissions from '../../../hooks/useCheckPermissions';
import { PERMISSIONS } from '../../../const/permissions.const';
import DisabledActionWrapper from '../../../yoello-lib/modules/components/DisabledActionWrapper';
const useStyles = makeStyles((theme:any) =>
  createStyles({
    root: {
      display: "flex",
      justifyContent:"center",
      alignItems:"center",
      fontSize:"1rem",
      color:"#8D98B7",
      "& >div":{
        position: "relative",
        color: "#FFFFFF",
        padding:" 0.5625rem 0.9375rem",
        background: "#1D8BF7",
        borderRadius: "8px",
        display:"flex",
        justifyContent:"center",
        alignItems:"center",
        fontSize:"0.8125rem",
        fontWeight:"normal",
        margin:"0 0.9375rem",
       "& >svg": {
          marginLeft:"6px",
          marginTop:"2px"
        },
        "&:hover": {
          cursor:"pointer"
        }
      },
    },
    disabled: {
      background: "rgba(0, 0, 0, 0.26) !important",
      cursor: "default !important"
    }
  }),
);

export function AddCreateMenuButtons(props:{hasAddButton?:boolean,onCreateMenuClick:()=>void,onAddItemsToMenuClick:()=>void}) {
  const { t } = useTranslation();
  const classes = useStyles();

  const { hasPermission, onFailedInteraction } = useCheckPermissions(PERMISSIONS.MENU_MANAGEMENT);

  return (
    <DisabledActionWrapper
      disabled={!hasPermission}
      onDisabledClick={onFailedInteraction}
    >
      <div className={classes.root}>
        {props.hasAddButton && <> <div 
          onClick={hasPermission ? props.onAddItemsToMenuClick : undefined}
          className={hasPermission ? "" : classes.disabled}
        >
          {t("menu.products.AddToMenu")}
          <RightArrowSVG />
        </div>
        {t("misc.or")} </>}
        <div 
          onClick={hasPermission ? props.onCreateMenuClick : undefined}
          className={hasPermission ? "" : classes.disabled}  
        >
        {t("manageMenu.manageMenuContainer.create")}
          <RightArrowSVG />
        </div>
      </div>
    </DisabledActionWrapper>
    
  )
}
